import React, { createRef } from "react";
import Select from "react-select";
import CircularProgress from "@material-ui/core/CircularProgress";
import Fade from "@material-ui/core/Fade";
import MonthWeekSelect from "../../../components/MonthWeekSelect";
import { TerritoryOptions } from "../../../Constants/retailer";
import VideoUpload from "../../../components/ContentUpload/VideoUpload";
import ImageUpload from "../../../components/ContentUpload/ImageUpload";
import Firebase from "../../../firebasehelper";
import YoutubeInput from "../../../components/ContentUpload/YoutubeInput";
import {
  GIF_UPLOAD,
  VIDEO_UPLOAD,
  YOUTUBE_URL,
  IMAGE_UPLOAD,
} from "../../../Constants/types";
import { ContentTypes } from "../../../Constants/selections";
import {
  UPLOADING_VIDEO,
  UPLOADING_GIF,
  UPLOADING_IMAGE,
} from "../../../Constants/string";
import MenuList from "../../../components/ContentUpload/MenuList";
import SingleValue from "../../../components/ContentUpload/SingleValue";
import "./index.css";

const TokenStyles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "white",
    width: "100%",
  }),
  option: (provided, _state) => ({
    ...provided,
    fontSize: 14,
    width: "100%",
  }),
};

class AddFeaturedContentModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      title: "",
      error_msg: "",
      territory: TerritoryOptions[0],
      currentToken: { label: "", value: "" },
      starting_monday: null,
      mediaUrl: "",
      mediaType: null,
      loading: false,
      loadingScript: "",
      taskList: [],
      uploadLimitReached: false,
    };
    this.modalRef = createRef();
  }

  componentDidMount() {
    const { territory = TerritoryOptions[0], brand } = this.props;
    this.setState({ territory });
    Firebase.getAllTokenEarnings((tokenEarnings) => {
      // get live tasks
      const super_tokenEarnings = tokenEarnings.filter((obj) => !obj.brand);
      const brand_tokenEarnings = tokenEarnings.filter((obj) =>
        obj.brand ? obj.brand.toLowerCase() === brand.toLowerCase() : false
      );
      let total_tokenEarnings = super_tokenEarnings.concat(brand_tokenEarnings);
      this.setState({ taskList: total_tokenEarnings });
      // Firebase.getAllHotTasks(brand.name, (hot_tasks) => {
      //   const result = total_tokenEarnings.filter((item) =>
      //     hot_tasks.includes(item.id)
      //   );
      //   console.log("live tasks", result);
      //   setLiveTasks(result);
      // });
    });
    document.addEventListener("mousedown", this.onOutsideClick);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.territory !== this.props.territory) {
      this.setState({ territory: this.props.territory });
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.onOutsideClick);
  }

  onOutsideClick = (e) => {
    if (!this.modalRef.current.contains(e.target)) {
      this.resetFormFields();
    }
  };

  handleInputChange = (field) => (event) => {
    this.setState({ [field]: event.target.value });
  };

  checkValidation = () => {
    const { title, mediaUrl, starting_monday } = this.state;
    const title_validation = title ? true : false;
    const content_validation = mediaUrl ? true : false;
    // const description_validation = description ? true : false;
    // const tag_validation = tag ? true : false;
    const week_validation = starting_monday ? true : false;
    const validation =
      title_validation && content_validation && week_validation;
    return validation;
  };

  uploadFeaturedContent = () => {
    const {
      title,
      starting_monday,
      mediaType,
      mediaUrl,
      taskList,
      currentToken,
    } = this.state;

    const { uploadFeaturedContent } = this.props;

    // Note: below is part of tokenEarnings
    const tokenValue = taskList.find((item) => item.id === currentToken.value);
    const toReferrals = this.props.userType === "prospect";
    const toMembers = this.props.userType === "member";

    const payload = {
      title,
      media_url: mediaUrl,
      media_type: mediaType.value,
      starting_monday,
      toMembers,
      toReferrals,
      tokenEarnings: null,
      // TODO: commented-out token earnings for now as its use here is unclear
      // tokenEarnings: mediaType.value === GIF_UPLOAD
      //     ? { value: tokenValue.page, label: currentToken.label }
      //     : null,
    };
    uploadFeaturedContent(payload);
    this.resetFormFields();
  };

  setWeek = (starting_monday) => {
    this.setState({ starting_monday });
  };

  showErrorMsg = () => {
    this.setState({ uploadLimitReached: true });
  };

  upload = async (contentType, mediaContent) => {
    const title = new Date().getTime().toString();
    const uploadFolder = "hotVideos";

    if (contentType === GIF_UPLOAD) {
      this.setState({ loading: true, loadingScript: UPLOADING_GIF });

      const gifUrl = await Firebase.uploadGif(
        mediaContent,
        title,
        uploadFolder + "/gifs"
      );
      this.setState({ loading: false, mediaUrl: gifUrl, loadingScript: "" });
    } else if (contentType === VIDEO_UPLOAD) {
      this.setState({ loading: true, loadingScript: UPLOADING_VIDEO });

      const uploadTask = Firebase.uploadVideo(
        mediaContent,
        uploadFolder + "/videos"
      );

      uploadTask.on(
        "state_changed",
        this.handleUploadProgress,
        this.handleUploadError,
        () => {
          uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            this.setState({
              loading: false,
              loadingScript: "",
              mediaUrl: downloadURL,
            });
          });
        }
      );
    } else if (contentType === IMAGE_UPLOAD) {
      this.setState({ loading: true, loadingScript: UPLOADING_IMAGE });

      const imgUrl = await Firebase.uploadGif(
        mediaContent,
        title,
        uploadFolder + "/images"
      );
      this.setState({ loading: false, mediaUrl: imgUrl, loadingScript: "" });
    } else if (contentType === YOUTUBE_URL) {
      this.setState({
        loading: false,
        mediaUrl: mediaContent,
        loadingScript: "",
      });
    }
  };

  tasksSelectorChangeHandler = (value) => {
    this.setState({ currentToken: value });
  };

  handleUploadProgress = (snapshot) => {
    var progress = (
      (snapshot.bytesTransferred / snapshot.totalBytes) *
      100
    ).toFixed(0);
    const loadingScript = UPLOADING_VIDEO + " " + progress + "%";
    this.setState({ loadingScript: loadingScript });
  };

  handleUploadError = (_error) => {
    this.setState({ loadingScript: "", loading: false });
  };

  handleSelectContentType = (type) => {
    this.setState({ mediaType: type });
  };

  resetFormFields = () => {
    this.setState({
      title: "",
      error_msg: "",
      territory: TerritoryOptions[0],
      currentToken: "",
      starting_monday: null,
      mediaUrl: "",
      mediaType: null,
      loading: false,
      loadingScript: "",
      uploadLimitReached: false,
    });
  };

  formatTitle = () => {
    const { userType } = this.props;
    return `Add Featured ${userType.slice(0, 1).toUpperCase()}${userType.slice(
      1
    )} Content`;
  };

  render() {
    const {
      title,
      loading,
      loadingScript,
      mediaType,
      taskList,
      currentToken,
      uploadLimitReached,
    } = this.state;

    const { hex, white, featuredContent, userType } = this.props;
    return (
      <div
        className="modal fade add-hotVideo-dialog"
        id="add_featuredContent_modal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="modal-default-fadein"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div
            className="modal-content add-hotVideo-content"
            ref={this.modalRef}
          >
            <div className="modal-header">
              <h5 className="modal-title">{this.formatTitle()}</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={this.resetFormFields}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body pb-1 add-hotVideo-dialog-body">
              <p className="add-hotVideo-title">Title</p>
              <input
                className="form-control form-control-md mb-3"
                onChange={this.handleInputChange("title")}
                value={title}
              />
              <div
                className="form-group row mb-2 mx-0"
                style={{ alignItems: "center" }}
              >
                <div style={{ width: 500 }}>
                  <Select
                    value={mediaType}
                    onChange={this.handleSelectContentType}
                    options={ContentTypes}
                    placeholder="What content would you like to post?"
                    isSearchable={false}
                    components={{ MenuList, SingleValue }}
                  />
                </div>
              </div>

              {mediaType && mediaType.value === YOUTUBE_URL && (
                <YoutubeInput
                  onChangeContent={(mediaContent) =>
                    this.upload(YOUTUBE_URL, mediaContent)
                  }
                />
              )}
              {mediaType && mediaType.value === IMAGE_UPLOAD && (
                <ImageUpload
                  showErrorMsg={this.showErrorMsg}
                  isGif={false}
                  preserveOrientation={false}
                  onChangeContent={(mediaContent) =>
                    this.upload(IMAGE_UPLOAD, mediaContent)
                  }
                />
              )}
              {mediaType && mediaType.value === GIF_UPLOAD && (
                <ImageUpload
                  showErrorMsg={this.showErrorMsg}
                  isGif={true}
                  onChangeContent={(mediaContent) =>
                    this.upload(GIF_UPLOAD, mediaContent)
                  }
                />
              )}
              {mediaType && mediaType.value === VIDEO_UPLOAD && (
                <VideoUpload
                  showErrorMsg={this.showErrorMsg}
                  onChangeContent={(mediaContent) =>
                    this.upload(VIDEO_UPLOAD, mediaContent)
                  }
                />
              )}

              {uploadLimitReached ? (
                <div className="error__container">
                  <div className="error__icon">!</div>
                  <p className="error__upload-limit-msg">
                    File size should be less than 140MB
                  </p>
                </div>
              ) : null}

              <Fade in={loading} unmountOnExit>
                <div style={{ display: "flex", gap: 4 }}>
                  <p>{loadingScript}</p>
                  <CircularProgress />
                </div>
              </Fade>
              {/* TODO: disabled token earning task. What is the purpose here? */}
              {/* {mediaType && mediaType.value === GIF_UPLOAD && (
                <Fragment>
                  <hr style={{ width: "100%" }} />
                  <div style={{ width: "100%" }}>
                    <Select
                      value={currentToken}
                      onChange={this.tasksSelectorChangeHandler}
                      styles={TokenStyles}
                      options={taskList.map((task) => ({
                        value: task.id,
                        label: task.title,
                      }))}
                      placeholder="Select Token Earning Task"
                    />
                  </div>
                </Fragment>
              )} */}
              <p className="add-hotVideo-title">Select Week</p>
              <MonthWeekSelect
                onSetWeek={this.setWeek}
                setResetFalse={this.setResetFalse}
                featuredContent={featuredContent}
                userType={userType}
              />
              <div className="add-hotVideo-footer">
                <button
                  className="btn btn-white btn-brand-hex"
                  data-dismiss="modal"
                  style={{
                    "--hover-color": hex || "white",
                    "--hover-text-color": white ? "white" : "black",
                  }}
                  onClick={this.resetFormFields}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-green"
                  onClick={this.uploadFeaturedContent}
                  disabled={!this.checkValidation()}
                  data-dismiss="modal"
                >
                  Add
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AddFeaturedContentModal;



// WEBPACK FOOTER //
// ./src/screens/HotTopic/AddFeaturedContentModal/index.js